<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-9 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ scheduleType?.name }} Schedules</span>
        </div>
        <div class="col col-md-3 d-print-none d-flex justify-content-end">
          <div class="type-header float-right pt-1">
            <mat-slide-toggle
              [checked]="showCompleted"
              color="accent"
              (change)="showCompleted = !showCompleted"
              >Show completed schedules</mat-slide-toggle
            >
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <!-- <span *ngIf="isExpanded || isShowing">Filter</span> -->
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <mat-list-item
          class="parent"
          (click)="showSubMenu = !showSubMenu"
          *ngIf="
            vs.validateRole('subscriberExtension', tokenInfo, scheduleType)
          "
        >
          <span *ngIf="isExpanded || isShowing"
            >Extension Request Notification</span
          >
          <mat-icon matListItemIcon class="yellow">more_time</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="openChooseUsers(scheduleTypeId)"
          class="child mt-10"
          *ngIf="(isExpanded || isShowing) && showSubMenu"
        >
          <span>Subscribe Users</span>
          <mat-icon matListItemIcon class="blue">person</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="openChooseRoles(scheduleTypeId)"
          class="child"
          *ngIf="(isExpanded || isShowing) && showSubMenu"
        >
          <span>Subscribe Roles</span>
          <mat-icon matListItemIcon class="blue">group</mat-icon>
        </mat-list-item>
        <mat-list-item
          (click)="openEditMessage()"
          class="child"
          *ngIf="(isExpanded || isShowing) && showSubMenu"
        >
          <span>Edit Request Extension Message</span>
          <mat-icon matListItemIcon class="yellow">edit_notifications</mat-icon>
        </mat-list-item>
      </mat-nav-list>

      <!-- Table -->
      <!-- <mat-list-item style="height: unset">
          <div *ngIf="isExpanded || isShowing"></div>
        </mat-list-item>
      </mat-nav-list> -->

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          (click)="addSchedule()"
          class="parent"
          *ngIf="
            vs.validateRole('createSchedule', tokenInfo, scheduleType) &&
            !remindersTabSelected
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New Schedule</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>

        <mat-list-item
          (click)="addReminder()"
          class="parent"
          *ngIf="
            vs.validateRole('createReminder', tokenInfo, scheduleType) &&
            remindersTabSelected
          "
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New Reminder</span
          >
          <mat-icon matListItemIcon class="blue">notification_add</mat-icon>
        </mat-list-item>
        <!-- <mat-list-item
          (click)="edit()"
          class="parent"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Modify Form</span
          >
          <mat-icon matListItemIcon color="accent">edit</mat-icon>
        </mat-list-item> -->
      </mat-nav-list>
      <!-- <mat-nav-list>
				<mat-list-item
					*ngIf="isSA()"
					(click)="settings()"
					class="parent line-top"
				>
					<span class="full-width" *ngIf="isExpanded || isShowing"
						>Settings</span
					>
					<mat-icon matListItemIcon class="gray">settings</mat-icon>
				</mat-list-item>
			</mat-nav-list> -->
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content container-fluid">
          <mat-tab-group
            animationDuration="0ms"
            (selectedTabChange)="tabChanged($event)"
            [(selectedIndex)]="selectedTab"
            [dynamicHeight]
          >
            <mat-tab *ngFor="let tab of scheduleTabs; let i = index">
              <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                  <mat-icon class="mr-2"> calendar_month </mat-icon>
                  {{ tab.name }}
                </div>
              </ng-template>
              <app-schedule-tab
                [showCompleted]="showCompleted"
                [tabIndex]="tabIndex"
                [tabName]="tab.name"
                [refreshData]="refreshData"
                [scheduleType]="scheduleType"
                [scheduleSubtype]="tab.scheduleSubtype"
                [scheduleTab]="tab"
                [filter]="filter"
                (locations)="setLocations($event)"
              ></app-schedule-tab>
            </mat-tab>
            <mat-tab>
              <ng-template mat-tab-label>
                <div class="d-flex align-items-center">
                  <mat-icon class="mr-2">notifications</mat-icon>
                  Reminders
                </div>
              </ng-template>
              <app-reminder-tab
                [tabIndex]="tabIndex"
                [tabName]="tabName"
                [scheduleType]="scheduleType"
                [filter]="filter"
              ></app-reminder-tab>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
